/* oxlint-disable jsx-a11y/alt-text */
import { useState, type ImgHTMLAttributes } from 'react';

type Props = {
    fallbackSrc?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'onError'>;

export const ImageWithFallback = ({ fallbackSrc, src: _src, ...rest }: Props) => {
    const [src, setSrc] = useState(_src);
    const [attempt, setAttempt] = useState(0);

    return (
        <img
            {...rest}
            src={src}
            onError={() => {
                if (attempt <= 2) {
                    setAttempt(v => v + 1);
                    setSrc(fallbackSrc || _src);
                }
            }}
        />
    );
};
